/**
 * A live licence photo proves that the guest has the document at hand for this
 * handover. It is not a host KYC requirement: the host is not the driver, and
 * making their inspection wait for somebody else's document blocks a legitimate
 * key handover for no safety benefit.
 */
export function requiresLiveLicenseEvidence(isGuest: boolean): boolean {
  return isGuest
}

/** Keep the submit gate and the readiness UI on the same product rule. */
export function hasRequiredLiveLicenseEvidence(
  isGuest: boolean,
  hasLicensePhoto: boolean,
): boolean {
  return !requiresLiveLicenseEvidence(isGuest) || hasLicensePhoto
}
